import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { MappedLink } from "@NA/Overrides/Widgets/Header/MainNavigation";
import React from "react";

interface Props {
    link: MappedLink;
    className?: string;
    href?: string;
    onClick?: (React.MouseEventHandler<HTMLAnchorElement> & ((event: React.MouseEvent<Element, MouseEvent>) => void)) | undefined
    extendedStyles?: LinkPresentationProps;
    dataTestSelector?: string;
    children?: React.ReactNode;
    newLink?: boolean;
    dealsLink?: boolean;
}

const ShopSectionCategoryLink = ({ 
    link,
    className,
    onClick,
    extendedStyles,
    dataTestSelector,
    children,
    newLink,
    dealsLink,
}: Props) => {
    const url = () => {
        if (newLink) {return link.properties['newProductsLink'];}
        if (dealsLink) {return link.properties['dealsLink'];}
        return link.url;
    }
    
    return (
        <Link
            className={className}
            {...extendedStyles}
            href={url()}
            data-test-selector={dataTestSelector}
            onClick={onClick}
        >
            {children}
        </Link>
    );
};

export default ShopSectionCategoryLink;